import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ModuleSize } from "../../../types/ModuleSize";

type ModuleSizeSelectionProps = {
  value?: ModuleSize;
  onChange: (value: ModuleSize) => void;
};

function ModuleSizeSelection({ value, onChange }: ModuleSizeSelectionProps) {
  return (
    <FormControl sx={{ width: "25%" }}>
      <InputLabel id="module-size-label">Size</InputLabel>
      <Select
        labelId="module-size-label"
        value={value}
        label="Size"
        onChange={(e) => onChange(e.target.value as ModuleSize)}
      >
        <MenuItem value="S">S</MenuItem>
        <MenuItem value="M">M</MenuItem>
        <MenuItem value="L">L</MenuItem>
        <MenuItem value="Q">Q</MenuItem>
      </Select>
    </FormControl>
  );
}

export default ModuleSizeSelection;
